import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Quote, Star } from 'lucide-react';
import { testimonials } from '../data/content';
export function TestimonialsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const featuredTestimonials = testimonials.filter(t => t.featured || t.id <= 3);
  useEffect(() => {
    if (isHovered) return;
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % featuredTestimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [isHovered, featuredTestimonials.length]);
  const next = () => setCurrentIndex(prev => (prev + 1) % featuredTestimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + featuredTestimonials.length) % featuredTestimonials.length);
  return <div className="relative max-w-5xl mx-auto" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-186">
      <div className="relative h-[400px] md:h-[350px] flex items-center justify-center" data-id="element-187">
        <AnimatePresence mode="wait" data-id="element-188">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.5
        }} className="absolute inset-0 w-full" data-id="element-189">
            <div className="glass p-8 md:p-12 rounded-3xl h-full flex flex-col items-center justify-center text-center relative overflow-hidden" data-id="element-190">
              <Quote className="absolute top-6 left-6 w-16 h-16 text-white/5" data-id="element-191" />
              <div className="flex text-gold mb-6" data-id="element-192">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-193" />)}
              </div>
              <p className="text-xl md:text-3xl font-serif text-white leading-relaxed mb-8 max-w-3xl" data-id="element-194">
                "{featuredTestimonials[currentIndex].quote}"
              </p>
              <div data-id="element-195">
                <p className="font-bold text-lg text-gold" data-id="element-196">
                  {featuredTestimonials[currentIndex].name}
                </p>
                <p className="text-beige-muted text-sm mt-1" data-id="element-197">
                  {featuredTestimonials[currentIndex].package || featuredTestimonials[currentIndex].category}{' '}
                  • {featuredTestimonials[currentIndex].sign}
                </p>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="flex items-center justify-center gap-6 mt-8" data-id="element-198">
        <button onClick={prev} className="p-2 rounded-full border border-white/10 text-beige hover:text-gold hover:border-gold transition-colors" data-id="element-199">
          <ChevronLeft className="w-5 h-5" data-id="element-200" />
        </button>
        <div className="flex gap-2" data-id="element-201">
          {featuredTestimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2 h-2 rounded-full transition-all duration-300 ${idx === currentIndex ? 'w-6 bg-gold' : 'bg-white/20 hover:bg-white/40'}`} data-id="element-202" />)}
        </div>
        <button onClick={next} className="p-2 rounded-full border border-white/10 text-beige hover:text-gold hover:border-gold transition-colors" data-id="element-203">
          <ChevronRight className="w-5 h-5" data-id="element-204" />
        </button>
      </div>
    </div>;
}